const OCCUPANCY_PRIMARY = "primary";
const OCCUPANCY_OCCASIONAL = "occasional";
const OCCUPANCY_INVESTMENT = "investment";

export const OCCUPANCY_OPTIONS = [
  {
    label: "Primera vivienda",
    value: OCCUPANCY_PRIMARY,
  },
  {
    label: "Vivienda ocasional",
    value: OCCUPANCY_OCCASIONAL,
  },
  {
    label: "Inversión",
    value: OCCUPANCY_INVESTMENT,
  },
];
